<template>
  <v-dialog
    v-model="addAccountDialog"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        Add Account
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter.native="actionClick()"
        >
          <v-text-field
            ref="name"
            v-model="name"
            :rules="[validateRequired]"
            label="Name"
            hint="e.g. Company Name Pty Ltd"
            persistent-hint
            required
            autofocus
            @blur="nameDirty = true"
          />
          <v-text-field
            ref="shortName"
            v-model="shortName"
            :rules="[validateRequired]"
            label="Short Name"
            hint="A shorter version of your company name e.g. Company Name or just Company"
            persistent-hint
            required
            @blur="shortNameDirty = true"
          />
          <v-text-field
            ref="email"
            v-model="email"
            :rules="[validateRequired, () => emailValid || 'Please enter a valid email address.']"
            label="Billing Email"
            type="email"
            required
            @blur="emailDirty = true; domainFromEmail()"
          />
          <v-text-field
            ref="domain"
            v-model="domain"
            :rules="[validateRequired, () => !emailAndDomainDirty || emailValidDomain || 'Warning: email/domain mismatch.']"
            label="Domain"
            hint="Your website url (without http*:// or www.) or the bit after the @ in your work email address"
            persistent-hint
            required
            @blur="domainDirty = true"
          />
          <v-select
            ref="type"
            v-model="type"
            :items="['Adviser', 'Single User', 'Standard Business']"
            :rules="[validateRequired]"
            label="Account Type"
            required
            @input="typeDirty = true"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          small
          text
          @click.stop="cancelClick()"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="!allValid"
          color="primary"
          small
          @click.stop="actionClick()"
        >
          Add Account
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validateRequired } from '@/utils/validationRules'

export default {
  name: 'AddAccountDialog',
  props: {
    addAccountDialog: { type: Boolean, default: false }
  },
  data: function () {
    return {
      valid: false,
      email: '',
      emailDirty: false,
      emailValid: false,
      name: '',
      nameDirty: false,
      shortName: '',
      shortNameDirty: false,
      domain: '',
      domainDirty: false,
      type: 'Adviser',
      typeDirty: false
    }
  },
  computed: {
    emailValidDomain() {
      return new RegExp('^.*@' + this.domain + '$').test(this.email)
    },
    nameValid() {
      return this.$refs.name.$refs.input.checkValidity()
    },
    shortNameValid() {
      return this.$refs.shortName.$refs.input.checkValidity()
    },
    domainValid() {
      return this.$refs.domain.$refs.input.checkValidity()
    },
    typeValid() {
      return this.$refs.type.$refs.input.checkValidity()
    },
    allValid() {
      return this.valid && this.emailValid && this.nameValid && this.shortNameValid && this.domainValid && this.typeValid
    },
    emailAndDomainDirty() {
      return this.emailDirty && this.domainDirty
    }
  },
  watch: {
    addAccountDialog: function (addAccountDialog) {
      if (addAccountDialog) {
        Object.assign(this.$data, this.$options.data())
        this.$refs.form.reset()
      }
    },
    email: function (email) {
      this.emailValid = this.$refs.email.$refs.input.checkValidity()
    }
  },
  methods: {
    validateRequired,
    domainFromEmail() {
      if (this.emailDirty && this.email.includes(this.domain)) {
        if (this.emailValid) {
          this.domain = this.email.split('@')[1]
        }
        return ''
      }
    },

    actionClick() {
      Object.entries(this.$data).forEach(([key, value]) => {
        if (key.includes('Dirty')) {
          this[key] = true
        }
      })

      if (this.$refs.form.validate()) {
        var data = Object.assign({}, (
          ({ email, domain, name, shortName, type }) =>
            ({ email, domain, name, shortName, type })
        )(this))

        this.$emit('actionClick', data)
      }
    },
    cancelClick() {
      this.$emit('cancelClick')
    }
  }
}
</script>
